module.exports = __webpack_public_path__ + "img/contatti.4e11e63f.png";